import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";

import { ResponseModel } from '../models/response.model';
import { HttpParams } from '@angular/common/http';
import { MessageService } from 'primeng/components/common/messageservice';
import { HubRouting } from '../models';
import { SortUtil } from '../infrastructure/sort.util';
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';

@Injectable()
export class HubRoutingService extends GeneralService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiGeneralUrl, "hubRouting");
  }

  getHubRoutingByPoHubId(poHubId: any): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("poHubId", poHubId);

    return super.getCustomApi("getHubRoutingByPoHubId", params);
  }

  async getHubRoutingByPoHubIdAsync(poHubId: any): Promise<HubRouting[]> {
    const res = await this.getHubRoutingByPoHubId(poHubId).toPromise();
    if (res.isSuccess) {
      let data = res.data as HubRouting[];
      data = SortUtil.sortAlphanumerical(data, "name");
      return data;
    }
    return null;
  }

  getHubRoutingByPoHubIdNew(poHubId: any): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("poHubId", poHubId);

    return super.getCustomApi("getHubRoutingByPoHubIdNew", params);
  }

  async getHubRoutingByPoHubIdNewAsync(poHubId: any): Promise<HubRouting[]> {
    const res = await this.getHubRoutingByPoHubIdNew(poHubId).toPromise();
    if (res.isSuccess) {
      let data = res.data as HubRouting[];
      data = SortUtil.sortAlphanumerical(data, "name");
      return data;
    }
    return null;
  }

  getDatasFromHub(stationHubId: any, hubRoutingId: any, isTruckDelivery: any): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("stationHubId", stationHubId);
    params = params.append("hubRoutingId", hubRoutingId);
    params = params.append("isTruckDelivery", isTruckDelivery);

    return super.getCustomApi("getDatasFromHub", params);
  }

  async getDatasFromHubAsync(stationHubId: any, hubRoutingId: any, isTruckDelivery: any): Promise<ResponseModel> {
    let res = await this.getDatasFromHub(stationHubId, hubRoutingId, isTruckDelivery).toPromise();
    return res;
  }

  getDatasFromHubNew(stationHubId: any, hubRoutingId: any, isTruckDelivery: any): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("stationHubId", stationHubId);
    params = params.append("hubRoutingId", hubRoutingId);
    params = params.append("isTruckDelivery", isTruckDelivery);

    return super.getCustomApi("getDatasFromHubNew", params);
  }

  async getDatasFromHubNewAsync(stationHubId: any, hubRoutingId: any, isTruckDelivery: any): Promise<ResponseModel> {
    let res = await this.getDatasFromHubNew(stationHubId, hubRoutingId, isTruckDelivery).toPromise();
    return res;
  }

  create(obj: Object): Observable<ResponseModel> {
    return super.postCustomApi("create", obj);
  }

  update(obj): Observable<ResponseModel> {
    return super.postCustomApi("update", obj);
  }

  getDataStreetJoinByWard(stationHubId: any, hubRoutingId: any, wardIds: string) {
    let params = new HttpParams();
    params = params.append("stationHubId", stationHubId);
    params = params.append("hubRoutingId", hubRoutingId);
    params = params.append("wardIds", wardIds);

    return super.getCustomApi("getDataStreetJoinByWard", params);
  }

  getCustomerIdsByHubRoutingId(hubRoutingId: number): Observable<ResponseModel> {
    let params = new HttpParams();
    params = params.append("hubRoutingId", hubRoutingId.toString());
    return super.getCustomApi("getCustomerIdsByHubRoutingId", params);
  }

  async getCustomerIdsByHubRoutingIdAsync(hubRoutingId: number): Promise<number[]> {
    const res = await this.getCustomerIdsByHubRoutingId(hubRoutingId).toPromise();
    if (res.isSuccess) {
      return res.data as number[];
    }
    return [];
  }

  async getHubRoutingByHubIdAsync(hubId: any, searchText: any): Promise<HubRouting[]> {
    let params = new HttpParams();
    params = params.append("hubId", hubId);
    params = params.append("searchText", searchText);

    const res = await super.getCustomApi("GetHubRoutingByHubId", params).toPromise();
    if (res.isSuccess) {
      let data = res.data as HubRouting[];
      return data;
    }
    return null;
  }

  async getShippingAddressAsync(isNewFilter: any, wardIdSetup: any, wardId: any, pageNumber: any, pageSize: any, searchText: any): Promise<any[]> {
    let params = new HttpParams();
    params = params.append("isNewFilter", isNewFilter);
    params = params.append("wardIdSetup", wardIdSetup);
    params = params.append("wardId", wardId);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    params = params.append("searchText", searchText);

    const res = await super.getCustomApi("GetShippingAddress", params).toPromise();
    if (res.isSuccess) {
      let data = res.data 
      return data;
    }
    return null;
  }

  async getRoutingPointsByWardAsync(wardId: any, hubRouting: any, pageNumber: any, pageSize: any, searchText: any): Promise<any[]> {
    let params = new HttpParams();
    params = params.append("wardId", wardId);
    params = params.append("hubRoutingId", hubRouting);
    params = params.append("pageNumber", pageNumber);
    params = params.append("pageSize", pageSize);
    params = params.append("searchText", searchText);

    const res = await super.getCustomApi("GetRoutingPointsByWard", params).toPromise();
    if (res.isSuccess) {
      let data = res.data 
      return data;
    }
    return null;
  }

  async checkRoutingPoints(obj: Object): Promise<any[]> {
    const res = await super.postCustomApi("CheckRoutingPoints", obj).toPromise();
    if (res.isSuccess) {
      let data = res.data 
      return data;
    }
    return null;
  }

  async saveWardRoutingPoints(obj: Object): Promise<any> {
    const res = await super.postCustomApi("SaveWardRoutingPoints", obj).toPromise();
    if (res.isSuccess) {
      let data = res.data 
      return data;
    }
    return null;
  }

  async deleteWardRoutingPoint(obj: Object): Promise<any> {
    const res = await super.postCustomApi("DeleteWardRoutingPoint", obj).toPromise();
    if (res.isSuccess) {
      let data = res.data 
      return data;
    }
    return null;
  }
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/services/hubRouting.service.ts